module.exports = __webpack_public_path__ + "img/UA.e94bb4e3.png";